import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'VH1',
    callsign: 'VH1HD',
    logoUrl: 'https://imgx.fubo.tv/station_logos/vh1_c.png',
    slug: 'vh1',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="VH1HD"
        title="Watch VH1 live online with Fubo"
        networkName="VH1"
      />
    </>
  )
}
